module.exports = __webpack_public_path__ + "img/accept-received-files.847e22a2.svg";